import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Support from "./routes/support/support";
import Privacy from "./routes/privacy-policy/privacy";
import Download from "./routes/download/download";
import Verification from "./routes/verification/verification";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="support" element={<Support />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="app" element={<Download />} />
      <Route path="verification" element={<Verification />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
